var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import * as cx from 'classnames';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { transformErrorToObject } from 'shared/error';
import Title from 'components/shared/Title';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import Subpage from './Subpage';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > .area {\n    width: 100%;\n    max-width: 1400px;\n    height: calc(100% - 85px - 50px);\n    border: 3px solid #f0f0f0;\n\n    > div {\n      float: left;\n      height: 100%;\n    }\n\n    > .list {\n      width: 200px;\n      overflow: auto;\n      background: #f0f0f0;\n\n      > .item {\n        width: 100%;\n        height: 60px;\n        padding: 10px;\n        line-height: 40px;\n        font-size: 16px;\n        cursor: pointer;\n      }\n\n      > .create-item {\n        width: 100%;\n        padding: 10px;\n        padding-top: 50px;\n\n        > form {\n          > input {\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            font-size: 14px;\n          }\n\n          > .error {\n            width: 100%;\n            height: 40px;\n            padding: 10px;\n            line-height: 20px;\n            color: red;\n          }\n\n          > button {\n            all: unset;\n            box-sizing: border-box;\n            cursor: pointer;\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            color: #fff;\n            background: #36c;\n            text-align: center;\n            border-radius: 10px;\n            font-size: 14px;\n            margin-top: 5px;\n          }\n        }\n      }\n\n      > .active {\n        background: #fff;\n      }\n    }\n\n    > .content {\n      width: calc(100% - 200px);\n      height: 100%;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > .area {\n    width: 100%;\n    max-width: 1400px;\n    height: calc(100% - 85px - 50px);\n    border: 3px solid #f0f0f0;\n\n    > div {\n      float: left;\n      height: 100%;\n    }\n\n    > .list {\n      width: 200px;\n      overflow: auto;\n      background: #f0f0f0;\n\n      > .item {\n        width: 100%;\n        height: 60px;\n        padding: 10px;\n        line-height: 40px;\n        font-size: 16px;\n        cursor: pointer;\n      }\n\n      > .create-item {\n        width: 100%;\n        padding: 10px;\n        padding-top: 50px;\n\n        > form {\n          > input {\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            font-size: 14px;\n          }\n\n          > .error {\n            width: 100%;\n            height: 40px;\n            padding: 10px;\n            line-height: 20px;\n            color: red;\n          }\n\n          > button {\n            all: unset;\n            box-sizing: border-box;\n            cursor: pointer;\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            color: #fff;\n            background: #36c;\n            text-align: center;\n            border-radius: 10px;\n            font-size: 14px;\n            margin-top: 5px;\n          }\n        }\n      }\n\n      > .active {\n        background: #fff;\n      }\n    }\n\n    > .content {\n      width: calc(100% - 200px);\n      height: 100%;\n    }\n  }\n"])));
export var GET_SUBPAGES = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetSubpages($projectName: String!, $pageName: String!) {\n    page(projectName: $projectName, pageName: $pageName) {\n      id\n      name\n      subpages {\n        id\n        name\n        urlName\n      }\n    }\n  }\n"], ["\n  query GetSubpages($projectName: String!, $pageName: String!) {\n    page(projectName: $projectName, pageName: $pageName) {\n      id\n      name\n      subpages {\n        id\n        name\n        urlName\n      }\n    }\n  }\n"])));
var CREATE_SUBPAGE = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation CreateSubpage($subpage: CreatingSubpagePayload!) {\n    createProjectSubpage(subpage: $subpage)\n  }\n"], ["\n  mutation CreateSubpage($subpage: CreatingSubpagePayload!) {\n    createProjectSubpage(subpage: $subpage)\n  }\n"])));
var SubpageList = /** @class */ (function (_super) {
    __extends(SubpageList, _super);
    function SubpageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentId: null
        };
        _this.isActiveItem = function (id, idx) {
            var currentId = _this.state.currentId;
            return (currentId === id) || (!currentId && idx === 0);
        };
        _this.setCurrentId = function (e, id) {
            e.preventDefault();
            _this.setState({
                currentId: id,
            });
        };
        _this.create = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var _a, project, pageName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, project = _a.project, pageName = _a.pageName;
                        return [4 /*yield*/, client.mutate({
                                mutation: CREATE_SUBPAGE,
                                variables: {
                                    subpage: {
                                        projectName: project,
                                        pageId: values.pageId,
                                        name: values.name,
                                        urlName: values.urlName,
                                    }
                                },
                                refetchQueries: [{
                                        query: GET_SUBPAGES,
                                        variables: {
                                            pageName: pageName,
                                            projectName: project,
                                        }
                                    }]
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    SubpageList.prototype.render = function () {
        var _this = this;
        var _a = this.props, project = _a.project, pageName = _a.pageName, title = _a.title;
        return (React.createElement(Query, { query: GET_SUBPAGES, variables: {
                pageName: pageName,
                projectName: project,
            } }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
            if (loading)
                return React.createElement(Loading, null);
            if (error || !data.page)
                return React.createElement(Error, { error: error });
            var _b = data.page, subpages = _b.subpages, id = _b.id;
            var currentId = _this.state.currentId || (subpages[0] && subpages[0].id);
            return (React.createElement(Container, null,
                React.createElement("div", { className: "title" },
                    React.createElement(Title, { title: title })),
                React.createElement("div", { className: "area" },
                    React.createElement("div", { className: "list" },
                        subpages.map(function (subpage, idx) {
                            return (React.createElement("div", { key: idx, className: cx('item', { active: _this.isActiveItem(subpage.id, idx) }), onClick: function (e) { return _this.setCurrentId(e, subpage.id); } }, subpage.name));
                        }),
                        React.createElement("div", { className: "create-item" },
                            React.createElement(Formik, { initialValues: { name: '', urlName: '' }, onSubmit: function (values, actions) {
                                    _this.create(__assign({}, values, { pageId: id }), client).then(function () {
                                        actions.setSubmitting(false);
                                        actions.resetForm();
                                    }, function (err) {
                                        actions.setSubmitting(false);
                                        actions.setErrors(transformErrorToObject(err));
                                    });
                                }, validate: function (values) {
                                    var errors = {};
                                    if (!values.name) {
                                        errors.name = '이름을 입력하세요.';
                                    }
                                    if (!values.urlName) {
                                        errors.urlName = '영어 이름을 입력하세요.';
                                    }
                                    if (!values.urlName.match(/^[a-z0-9\-]*$/)) {
                                        errors.urlName = '영어 이름은 소문자 알파벳과 - 만 사용 가능합니다.';
                                    }
                                    return errors;
                                } }, function (_a) {
                                var isSubmitting = _a.isSubmitting;
                                return (React.createElement(Form, null,
                                    React.createElement(Field, { name: "name", placeholder: "\uC774\uB984" }),
                                    React.createElement(ErrorMessage, { name: "name", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                                    React.createElement(Field, { name: "urlName", placeholder: "\uC601\uC5B4\uC774\uB984" }),
                                    React.createElement(ErrorMessage, { name: "urlName", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                                    React.createElement("button", { type: "submit", disabled: isSubmitting }, "\uC0DD\uC131")));
                            }))),
                    React.createElement("div", { className: "content" }, currentId && React.createElement(Subpage, { id: currentId })))));
        }));
    };
    return SubpageList;
}(React.Component));
export default SubpageList;
var templateObject_1, templateObject_2, templateObject_3;
